// extracted by mini-css-extract-plugin
export default {"tech":"HW14_tech__V-sh0","loading":"HW14_loading__sHYO8"};